"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _qrcode = _interopRequireDefault(require("qrcode"));
var _default = exports.default = {
  data() {
    return {
      options: {
        width: 400,
        height: 400
      }
    };
  },
  async mounted() {
    await _qrcode.default.toCanvas(this.$refs.qrcodeCanvas, `${window.location.origin}/h5/leads/logistics/collect`, this.options);
  },
  methods: {
    handleCopy() {
      navigator.clipboard.writeText(`${window.location.origin}/h5/leads/logistics/collect`);
      this.$message.success('复制完成');
    }
  }
};